/**
 * `scroll-behavior: smooth` in CSS already respects `prefers-reduced-motion`
 * (see `index.css`), but `Element.scrollIntoView({ behavior: "smooth" })`
 * called from JavaScript does not -- an explicit `behavior` always overrides
 * the CSS property. Callers that scroll programmatically must check this
 * themselves.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
